import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, ShieldCheck, CreditCard, Package } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0f0f0f] text-gray-300" data-id="element-68">
      {/* Trust strip */}
      <div className="border-b border-white/10" data-id="element-69">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-70">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-71">
            {[{
            icon: Truck,
            title: 'Nationwide Shipping',
            desc: 'Orders ship across the U.S.'
          }, {
            icon: ShieldCheck,
            title: 'Secure Online Checkout',
            desc: 'Encrypted checkout flow'
          }, {
            icon: Package,
            title: 'Systems, Bundles & Modules',
            desc: 'Full Yarbo Y Series catalog'
          }, {
            icon: CreditCard,
            title: 'In Stock & Ready to Ship',
            desc: 'Available now'
          }].map(({
            icon: Icon,
            title,
            desc
          }) => <div key={title} className="flex items-start gap-3" data-id="element-72">
                <Icon className="w-6 h-6 text-yarbo-yellow flex-shrink-0 mt-0.5" data-id="element-73" />
                <div data-id="element-74">
                  <div className="font-bold text-sm text-white" data-id="element-75">{title}</div>
                  <div className="text-xs text-gray-400 mt-0.5" data-id="element-76">{desc}</div>
                </div>
              </div>)}
          </div>
        </div>
      </div>

      {/* Main */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-id="element-77">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-10" data-id="element-78">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-79">
            <Link to="/" className="flex flex-col mb-4" data-id="element-80">
              <span className="text-2xl font-extrabold tracking-tight text-white leading-none" data-id="element-81">
                Merem Robotics
              </span>
              <span className="text-xs font-medium text-gray-400 tracking-wide mt-1" data-id="element-82">
                Yarbo robotic yard-care systems
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-gray-400 mb-4" data-id="element-83">
              Merem Robotics sells Yarbo robotic yard-care systems, modules,
              bundles, and accessories online.
            </p>
            <p className="text-xs text-gray-500" data-id="element-84">
              Michigan-based. Shipping nationwide.
            </p>
          </div>

          {/* Shop */}
          <div data-id="element-85">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-5 text-white" data-id="element-86">
              Shop
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-87">
              <li data-id="element-88">
                <Link to="/shop" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-89">
                  Shop All Products
                </Link>
              </li>
              <li data-id="element-90">
                <Link to="/category/lawn-mowers" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-91">
                  Robot Lawn Mowers
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/category/snow-blowers" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-93">
                  Robotic Snow Blowers
                </Link>
              </li>
              <li data-id="element-94">
                <Link to="/category/leaf-blowers" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-95">
                  Leaf Blowers
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/category/bundles" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-97">
                  Bundles
                </Link>
              </li>
              <li data-id="element-98">
                <Link to="/category/modules" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-99">
                  Modules
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/category/accessories" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-101">
                  Accessories
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer */}
          <div data-id="element-102">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-5 text-white" data-id="element-103">
              Customer Help
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-104">
              <li data-id="element-105">
                <Link to="/faq" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-106">
                  FAQ
                </Link>
              </li>
              <li data-id="element-107">
                <Link to="/contact" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-108">
                  Contact
                </Link>
              </li>
              <li data-id="element-109">
                <Link to="/contact" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-110">
                  Shipping &amp; Returns
                </Link>
              </li>
              <li data-id="element-111">
                <Link to="/contact" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-112">
                  Order Support
                </Link>
              </li>
              <li data-id="element-113">
                <Link to="/compare" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-114">
                  Compare Systems
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-115">
            <h4 className="text-sm font-bold uppercase tracking-wider mb-5 text-white" data-id="element-116">
              Company
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-117">
              <li data-id="element-118">
                <Link to="/contact" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-119">
                  About Merem Robotics
                </Link>
              </li>
              <li data-id="element-120">
                <Link to="/contact" className="text-gray-400 hover:text-yarbo-yellow transition-colors" data-id="element-121">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-122">
          <p className="text-xs text-gray-500" data-id="element-123">
            &copy; {new Date().getFullYear()} Merem Robotics. All rights
            reserved.
          </p>
          <p className="text-xs text-gray-500 max-w-3xl text-left md:text-right" data-id="element-124">
            Yarbo product names, images, and trademarks belong to their
            respective owner. Merem Robotics is a retailer of Yarbo robotic
            yard-care products.
          </p>
        </div>
      </div>
    </footer>;
}